import { render, staticRenderFns } from "./UserSideMenu.vue?vue&type=template&id=0034f2fb"
import script from "./UserSideMenu.vue?vue&type=script&lang=js"
export * from "./UserSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0034f2fb')) {
      api.createRecord('0034f2fb', component.options)
    } else {
      api.reload('0034f2fb', component.options)
    }
    module.hot.accept("./UserSideMenu.vue?vue&type=template&id=0034f2fb", function () {
      api.rerender('0034f2fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserSideMenu.vue"
export default component.exports